﻿import JsRender from 'jsrender';
import * as bootstrap from 'bootstrap';

var processing = false;
var helpers = {
   cssClass: function (val: string): string { return (val.toLowerCase() !== 'other') ? val.toLowerCase().replace(' ', '') : 'link'; },
   networkName: function (val: string): string { return (val.toLowerCase() !== 'other') ? val : 'Other Profile'; }
};

const modalElement = document.getElementById('contactModal');
if (modalElement) {
   const modalBody = modalElement.querySelector('.modal-body');
   const contactModal = new bootstrap.Modal(modalElement, {});
   if (contactModal && modalBody) {
      document.querySelectorAll<HTMLElement>('[data-person]').forEach(function (element) {
         element.addEventListener('click', function () {
            if (!processing) {
               processing = true;
               var personId = element.dataset.person;
               fetch('/umbraco/api/PersonsApi/GetById/?id=' + personId)
                  .then(async (response) => {
                     console.log(response);
                     if (response.ok) {
                        const result = await response.json();
                        if (result.success === true) {
                           var tmpl = JsRender.templates('#contactModalTpl');
                           var renderedModalHtml = tmpl.render(result.data, helpers);
                           modalBody.innerHTML = renderedModalHtml;
                           console.log(modalBody);
                           contactModal.show();
                        }
                     }
                     processing = false;
                  })
                  .catch(reason => {
                     console.error(reason);
                     processing = false;
                  });
            }
         });
      });
   }
}